/**
 * Created by WebStorm.
 * User: nirongxu
 * Date: 2018/12/8
 * Description: 文件描述
 */

import en from './en'
import cn from './cn'
export default {
  "zh-CN":cn,
  'en-US':en
}



// WEBPACK FOOTER //
// ./src/i18n/lang/index.js